import { RewardType } from '../Rewards/RewardType';
import { IBotEntryPoint } from './EntryPoints/IBotEntryPoint';
import { ICustomEntryPoint } from './EntryPoints/ICustomEntryPoint';
import { ICrossPromoEntryPoint } from './EntryPoints/ICrossPromoEntryPoint';
import { IAdCampaignEntryPoint } from './EntryPoints/IAdCampaignEntryPoint';
import { EntryPointType } from './EntryPointType';
import { PayloadType } from '../SDK/PayloadType';
import { IBotMessagePayload } from './Payloads/IBotMessagePayload';
import { IProgressRestorePayload } from './Payloads/IProgressRestorePayload';
import { ICrossPromoPayload } from './Payloads/ICrossPromoPayload';
import { ICustomPayload } from './Payloads/ICustomPayload';

export type EncryptedEntryPoint = {
    enc: string;
};

/** @deprecated */
export type EntryPoint = ICustomEntryPoint | IBotEntryPoint | ICrossPromoEntryPoint | IAdCampaignEntryPoint;

export interface IBotMessageGift {
    giftData: { amount: number; itemId: RewardType }[];
    id: string | number;
}

export interface IBotMessageAdditions {
    restoreLevelProgress?: number;
    restoreCertainLevelProgress?: IRestoreLevel[];
}

export interface IRestoreLevel {
    level: number;
    stars: number;
}

/** @deprecated */
export function isProgressRestorePayload(payload: any): payload is IProgressRestorePayload {
    return (
        typeof payload === 'object' &&
        typeof (payload as IProgressRestorePayload).payloadId === 'number' &&
        typeof (payload as IProgressRestorePayload).userId === 'string' &&
        typeof (payload as IProgressRestorePayload).additions === 'object'
    );
}

/** @deprecated */
export function isRewardedPayloadLegacy(entryPoint: any): entryPoint is ICustomPayload {
    return !!entryPoint && !!entryPoint.payload && !!(entryPoint.payload as ICustomPayload).messageId;
}

/** @deprecated */
export function isAdCampaignEntryPoint(entryPoint: EntryPoint): entryPoint is IAdCampaignEntryPoint {
    return (
        !!entryPoint &&
        (entryPoint as IAdCampaignEntryPoint).entryPoint === EntryPointType.AD &&
        !!(entryPoint as IAdCampaignEntryPoint).adPayload &&
        !!(entryPoint as IAdCampaignEntryPoint).adPayload.adID &&
        !!(entryPoint as IAdCampaignEntryPoint).adPayload.adName &&
        !!(entryPoint as IAdCampaignEntryPoint).adPayload.adType
    );
}

export function isBotMessagePayload(data: unknown): data is IBotMessagePayload {
    let payload = data as IBotMessagePayload;
    return (
        typeof payload === 'object' &&
        typeof payload.gift === 'object' &&
        (typeof payload.gift.id === 'string' || typeof payload.gift.id === 'number')
    );
}

export function isCrossPromoEntryPoint(data: unknown): data is ICrossPromoEntryPoint {
    return isCrossPromoPayload((data as ICrossPromoEntryPoint).payload);
}

// TODO: Further verification needs to be done to be sure we are actually checking the right values
export function isCrossPromoPayload(data: unknown): data is ICrossPromoPayload {
    return (
        !!data &&
        (typeof (data as ICrossPromoPayload).originGameId === 'string' ||
            (data as ICrossPromoPayload)._value === 'game_switch')
    );
}

export function isCustomEntryPoint(data: unknown): data is ICustomEntryPoint {
    return isCustomEntryPayload((data as ICustomEntryPoint).payload);
}

export function isCustomEntryPayload(data: unknown): data is ICustomPayload {
    const entryPoint = data as ICustomPayload;
    return !!entryPoint?.data && Object.values(PayloadType).includes(entryPoint.data);
}
